import { useIntl } from "react-intl";

const ExternalServices = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ExternalServices.header",
            defaultMessage: "External services"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ExternalServices.body",
            defaultMessage:
                "Connect to the external services that you depend on in a status page to know the moment an incident is reported and set alerting rules to respond to it quickly."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ExternalServices;
